import { z } from 'zod';

export const createTimeLogInputSchema = z.object({
  durationInput: z.string().trim().min(1).max(40),
  loggedAt: z.string().datetime().optional(),
  description: z.string().trim().max(500).optional(),
});
export type CreateTimeLogInput = z.infer<typeof createTimeLogInputSchema>;

export const updateTimeLogInputSchema = z.object({
  durationInput: z.string().trim().min(1).max(40).optional(),
  loggedAt: z.string().datetime().optional(),
  description: z.string().trim().max(500).nullable().optional(),
});
export type UpdateTimeLogInput = z.infer<typeof updateTimeLogInputSchema>;
